module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex items-center"
  }, [_c('h5', {
    staticClass: "text-base font-semibold text-gray-500 mr-2"
  }, [_vm._v(_vm._s(_vm.anonymousUser.name))]), _vm._v(" "), _c('img', {
    staticClass: "w-9 h-9 rounded-full bg-white object-cover cursor-pointer hover:bg-green-500",
    attrs: {
      "src": _vm.anonymousUser.avatar_url
    },
    on: {
      "click": function($event) {
        _vm.isOpenAnonymousModal = true
      }
    }
  })]), _vm._v(" "), (_vm.isOpenAnonymousModal) ? _c('AnonymousCharacterDescriptionModal', {
    attrs: {
      "anonymous_identity": _vm.getMyRTUserDetails
    },
    on: {
      "close": function($event) {
        _vm.isOpenAnonymousModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3d1bfbd2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/identityReveal/identityReveal.vue
// module id = 1295
// module chunks = 61